// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6353 ? "reactPlayerPreview" : chunkId) + "." + {"6353":"8e16533ebcdea5be","9306":"16a3d67e8441365b"}[chunkId] + ".js";
};